import type { InjectionKey, Ref } from 'vue'

export const DefaultStatuses = Symbol('DefaultStatuses') as symbol & {
  __type: Ref<string[]>
}

export const ContactAccounts: InjectionKey<Ref<string[]>> = Symbol('ContactAccounts')
